<div class="article-description-editor">
  <sc-flex vertical fitHeight stretchContent
      class="no-field-space">
      <sc-dialog-title>
        <sc-dictionary-label dictionaryKey="erp.ui.article-description-editor.title"></sc-dictionary-label>
      </sc-dialog-title>

      <sc-scroll-pane>
          <sc-padding>
              <form [formGroup]="formGroup">
                  <sc-flex vertical stretchContent>
                      <mat-form-field appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="erp.entity.articledescription.usage"></sc-dictionary-label>
                          </mat-label>
                          <input matInput formControlName="usage">
                      </mat-form-field>
                      <sc-content-spacer vertical></sc-content-spacer>
                      <sc-dictionary-field [model]="description?.title" [maxlength]="255"
                          defaultLabel="Title" labelDictionaryKey="erp.entity.articledescription.title"
                          (dictionaryChanged)="onTitleChanged($event)" [required]="true">
                      </sc-dictionary-field>
                      <sc-content-spacer vertical></sc-content-spacer>
                      <sc-dictionary-text-field [rows]="5" [model]="description?.text" [maxlength]="255"
                          defaultLabel="Text" labelDictionaryKey="erp.entity.articledescription.text"
                          (dictionaryChanged)="onTextChanged($event)">
                      </sc-dictionary-text-field>
                  </sc-flex>
              </form>
          </sc-padding>
      </sc-scroll-pane>

      <sc-actionbar>
          <sc-content-spacer grow></sc-content-spacer>
          <button mat-stroked-button (click)="onClose()">
            <sc-dictionary-label dictionaryKey="erp.ui.article-description-editor.action.cancel"></sc-dictionary-label>
          </button>
          <sc-content-spacer></sc-content-spacer>
          <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled()">
            <sc-dictionary-label dictionaryKey="erp.ui.article-description-editor.action.confirm"></sc-dictionary-label>
          </button>
      </sc-actionbar>
  </sc-flex>
</div>
